import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMap, MapMarker, MapMarkerClusterer } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { ComparableSalesPageRoutingModule } from './comparable-sales-routing.module';
import { ComparableSalesPageComponent } from './comparable-sales.page';

@NgModule({
  declarations: [ComparableSalesPageComponent],
  imports: [
    FormsModule,
    IonicModule,
    ComparableSalesPageRoutingModule,
    MiscModule,
    CommonModule,
    GoogleMap,
    MapMarker,
    MapMarkerClusterer
  ]
})
export class ComparableSalesPageModule {}
